<ohp-recommended-react-content [fileType]="fileType"></ohp-recommended-react-content>
